export default {

  namespaced: true,

  state: () => ({

    products : {
      data : []
    }

  }),

  mutations: {

  },

  actions: {

    async getProducts({ dispatch }, params) {
      
      const response = await axios.get('/erp/product/product', { params });

      return response.data;

    },

    async getProduct({ dispatch }, id) {
      
      const response = await axios.get('/erp/product/product/' + id);

      return response.data;

    },

    async getProductsHasRegistered({ dispatch }, params) {

      const data = await axios.get('/erp/product/product', { params });

      return data;

    },

  }
}
